import { observer } from "mobx-react";
import OnBoardingScreenTitle from "../../../onboarding-screen-title/onboarding-screen-title";
import { IWalletConfigurationOnboardingScreenProps } from "../../wallet-configuration-onboarding-screen";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import WalletConfigurationSettings from "../../wallet-configuration-settings/wallet-configuration-settings";
import WalletPaymentMethod from "../../../../../billing/components/wallet/wallet-payment-method";
import FirstChargeBonusPromotion from "../../first-change-bonus-promotion/first-change-bonus-promotion";

const PaymentMethodConfiguration: React.FC<IWalletConfigurationOnboardingScreenProps> = observer((props) => {
    const { walletStore, getTranslation, scope, store } = props;

    return (
        <>
            <div className="wallet-configuration-onboarding-screen-title-wrapper">
                <OnBoardingScreenTitle
                    titleText={getTranslation("CONFIGURE_WALLET_SCREEN_TITLE_2",scope)}
                    descriptionText={getTranslation("CONFIGURE_WALLET_SCREEN_DESCRIPTION_2",scope)}
                    maxWidth={500}
                />
            </div>

            <div className="wallet-configuration-onboarding-screen-content-wrapper">
                <div className="wallet-configuration-onboarding-screen-form">
                    <div className="wallet-configuration-onboarding-screen-form-field">
                        <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>1. {getTranslation("STEP_TITLE_3", scope)}</FontBody1>
                        <div className="billing-page-new">
                            <WalletPaymentMethod walletStore={walletStore} shouldConfirmPaymentMethodDeletions={false} />
                        </div>
                    </div>

                    <FirstChargeBonusPromotion />
                    
                    <div className={`wallet-configuration-onboarding-screen-form-field ${walletStore.hasPaymentMethod ? '' : 'disabled'}`}>
                        <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>2. {getTranslation("CONFIGURE_WALLET_SETTINGS", scope)}</FontBody1>
                        <div className="wallet-configuration-onboarding-screen-form-field-description">
                            <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation("CONFIGURE_WALLET_SETTINGS_DESCRIPTION", scope)}</FontBody1>
                        </div>
                        <WalletConfigurationSettings walletStore={walletStore} validationErrors={store.validationErrors} />
                    </div>
                </div>
            </div>       
        </>
    );
});

export default PaymentMethodConfiguration;